import React, { useState, useEffect } from "react";
import { menu } from "../../utils/menu";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { changeNavbar } from "../../redux/actions/navbar/navbarActions";
import styles from "./SideDrawerMobile.module.scss";
import LogoSmall from "../../assets/images/Logos/paymentgateway.png";
import Times from "../../assets/images/Icons/CloseIcon.svg";
import signout from "../../assets/images/Icons/signout.svg";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function SideDrawerMobile({
  selectedMenu,
  selectedNav,
  setSelectedMenu,
  setSelectedNav,
  setCollapse,
  collapse,
}: {
  selectedMenu: number;
  selectedNav: number;
  setSelectedMenu: any;
  setSelectedNav: any;
  collapse: boolean;
  setCollapse: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  interface clickType {
    id: null | number;
    isClick: Boolean;
  }
  const [isClick, setIsClick] = useState<clickType>({
    id: null,
    isClick: false,
  });
  const [isDesktop, setDesktop] = useState(window.innerWidth > 920);

  const dispatch = useDispatch();
  const history = useHistory();
  const openMenu = ({ url }: any) => {
    history.push(url);
  };
  const signOutHandler = () => {
    sessionStorage.clear();
    setSelectedMenu(1);
    setSelectedNav(1);
    window.location.href = "/";
    localStorage.clear();
  };

  useEffect(() => {
    console.log("isClick:", isClick);
  }, [isClick]);

  return (
    <div className={styles.sidewrapper}>
      <div className={styles.logowrapper}>
        <img className={styles.logo} src={LogoSmall} alt='' />
        {/* <span className={styles.logocontent}>Admin</span> */}
      </div>
      <div className={styles.flexwrapper}>
        <div>
          <div className={styles.menuwrapper}>
            {menu.map(({ id, menuName, url, icon, nested }) => (
              <>
                <div
                  className={
                    selectedMenu === id
                      ? styles.menuActiveIndividual
                      : styles.menuIndividual
                  }
                >
                  <div
                    className={
                      selectedMenu === id && url
                        ? styles.iconActive
                        : styles.icon
                    }
                  >
                    {icon}
                  </div>
                  <div
                    key={id}
                    className={
                      selectedMenu === id && url
                        ? styles.activeMenu
                        : styles.menuItem
                    }
                    onClick={() => {
                      url && openMenu({ url });
                      url && setSelectedMenu(id);
                      url && setSelectedNav(id);
                      url && dispatch(changeNavbar(menuName));
                      !url &&
                        setIsClick({
                          id: id,
                          isClick: !isClick.isClick,
                        });
                      setCollapse(false);
                    }}
                  >
                    {selectedMenu === id ? (
                      <div className={styles.activeColor}>
                        <div className={styles.activeColorText}>{menuName}</div>
                      </div>
                    ) : (
                      <div style={{ display: "flex" }}>
                        <div className={styles.inactiveColorText}>
                          {menuName}
                        </div>
                        {!url && !isClick.isClick && (
                          <KeyboardArrowDownIcon sx={{ marginLeft: "5px" }} />
                        )}
                        {!url && isClick.isClick && (
                          <KeyboardArrowUpIcon sx={{ marginLeft: "5px" }} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {nested &&
                    isClick.isClick &&
                    isClick.id === id &&
                    nested.map(({ id, menuName, url }) => (
                      <div
                        className={
                          selectedMenu === id
                            ? styles.menuActiveIndividual
                            : styles.menuIndividual
                        }
                      >
                        <div
                          key={id}
                          className={
                            selectedMenu === id
                              ? styles.activeMenuNested
                              : styles.menuItemNested
                          }
                          onClick={() => {
                            openMenu({ url });
                            setSelectedMenu(id);
                            setSelectedNav(id);
                            dispatch(changeNavbar(menuName));
                            setCollapse(false);
                          }}
                        >
                          {selectedMenu === id ? (
                            <div className={styles.activeColor}>
                              <div className={styles.activeColorText}>
                                {menuName}
                              </div>
                            </div>
                          ) : (
                            <div className={styles.inactiveColorText}>
                              {menuName}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ))}
          </div>
          {}
          <div onClick={() => setCollapse(!collapse)} className={styles.close}>
            <img className={styles.closeIcon} src={Times} alt='' />
            <span className={styles.closeContent}>Minimize</span>
          </div>

          <div onClick={signOutHandler} className={styles.closeSign}>
            <img className={styles.closeIcon} src={signout} alt='' />
            <span
              style={{ paddingLeft: collapse ? "30px" : "" }}
              className={styles.closeContent}
            >
              Sign Out
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideDrawerMobile;
